import moment from 'moment';
import 'moment/locale/id';

export const currentYear = () => {
	return moment().year();
};

export const convertToId = time => {
	return moment(time)
		.locale('id')
		.format('dddd, Do MMMM YYYY');
};

export const convertToIdMonthDate = time => {
	return moment(time)
		.locale('id')
		.format('Do MMM YY');
};

export const convertToDefaultFormat = time => {
	return moment(time)
		.locale('id')
		.format('YYYY-MM-Do');
};
